import { SalaryFrequency } from "@/shared/enums/salaryFrequency.enum";

export const getAverateAmount = (frequency:string , amount: any) => {
    const lFrequency = frequency.toLocaleLowerCase();
    let nAmount: number;

    if (typeof amount === 'string') {
        nAmount = parseInt(amount.replace(/,/g, ""), 10);
    } else if (typeof amount === 'number') {
        nAmount = amount;
    } else {
        throw new Error('Invalid amount type');
    }
    let monthlyAmount;

    if (lFrequency === SalaryFrequency.Annually) {
        monthlyAmount = nAmount / 12;
    } else if (lFrequency === SalaryFrequency.Weekly) {
        monthlyAmount = (nAmount * 52) / 12;
    } else if (lFrequency === SalaryFrequency.Fortnightly) {
        monthlyAmount = (nAmount * 26) / 12;
    } else {
        monthlyAmount = nAmount;
    }

    return monthlyAmount;
}